import { useQuery } from "hooks/useQuery";
import { getCombinedStrategyCharts } from "../service";

export const useCombinedStrategyCharts = () => {
  const { isLoading, data, error, refetch } = useQuery({
    key: "combinedStrategyCharts",
    queryKey: ["combinedStrategyCharts"],
    queryFn: () => getCombinedStrategyCharts(),
  });

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
